"use client";

import React from "react";

/**
 * InputGroup - Flex wrapper for inputs with optional prepend/append.
 */
function InputGroupComponent({ children, className = "", size, ...props }) {
  const sizeClasses = {
    sm: "[&_input]:h-8 [&_input]:text-sm [&_.input-group-text]:text-sm [&_.input-group-text]:py-1",
    lg: "[&_input]:h-12 [&_input]:text-lg [&_.input-group-text]:text-lg [&_.input-group-text]:py-2",
  };

  return (
    <div
      className={`flex flex-wrap items-stretch w-full ${sizeClasses[size] || ""} ${className}`.trim()}
      role="group"
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * InputGroup.Text - Addon text element for InputGroup.
 */
function InputGroupText({ children, className = "", ...props }) {
  return (
    <span
      className={`input-group-text flex items-center px-3 py-1.5 text-base text-darkBlack bg-lightGrey border border-lightGrey3 rounded-none first:rounded-l last:rounded-r ${className}`.trim()}
      {...props}
    >
      {children}
    </span>
  );
}

export const InputGroup = Object.assign(InputGroupComponent, {
  Text: InputGroupText,
});

